_collow.components.InputStepPage = class InputStepPage extends (
    _collow.components.Base
  ) {
    root;
    elements;
    params;
    inputs;
    currentStepName;
    currentStepNumber;
    messageParagraph;
    inputContainer;
  
    constructor(root, elements, params) {
      super();
  
      this.root = root;
      this.elements = elements;
      this.params = params;
      this.inputs = document.querySelectorAll("input");

      this.inputs.forEach(input => input.addEventListener('input', this.checkInputCaracters));
    }

    checkInputCaracters = () => {
      this.currentStepNumber = document.querySelector(`.content-section[active="true"]`).getAttribute("step-number").split("-")[1];
      this.currentStepName = document.querySelector(`.content-section[active="true"]`).getAttribute("step-name");
      this.messageParagraph = document.querySelector(`[current-step="${this.currentStepName}"] .input-message`)
      this.inputContainer = document.querySelector(`.step-input-container[current-step="${this.currentStepName}"]`)
      const inputChanged = document.querySelector(`.content-section[active="true"] input`)
      const totalCaracters = inputChanged.value.length

      if(totalCaracters == 0) {
        this.handleNextStep("disable")
      } else if(totalCaracters > 150) {
        this.showMessageError()
        this.handleNextStep("disable")
      } else {
        const isMsgError = Array.from(this.inputContainer.classList).includes("error-message")
        if(isMsgError) this.hideMessageError()
          this.handleNextStep("enable", inputChanged.value)
      }
    }

    handleNextStep = (action, inputValue) => {
      if(action === "disable") {
        this.dispatch(this.root, "_fill-step-circle", {step: this.currentStepNumber, completed: false}); //NAO PREENCHO O CICULO
        this.dispatch(this.root, "_toogle-next-btn", {step: this.currentStepNumber, completed: false, data: "null"}); //NAO ABILITO O BOTAO NEXT
      } else if(action === "enable") {
        this.dispatch(this.root, "_toogle-next-btn", {step: this.currentStepNumber, completed: true, data: inputValue});
      }
    }

    showMessageError = () => {
      const messageError = '<i class="fa-solid fa-triangle-exclamation" style="color: #ff0000;margin-right: 4px;"></i> Topic is too long'

      this.messageParagraph.innerHTML = messageError
      this.inputContainer.classList.add("error-message")
    }

    hideMessageError = () => {
      const messageDefault = 'Max 150 characters'

      this.messageParagraph.innerHTML = messageDefault
      this.inputContainer.classList.remove("error-message")
    }
};
  
   
  
  
  
  
  
  